export const services = {
  'seo.title': 'Services — Nutritional Support Programs | Sofia and Elena',
  'seo.description': 'Choose your program: VIP Tandem support, FMD protocol for cellular rejuvenation, child nutrition or group intensives. Individual approach from two expert nutritionists.',
  'seo.keywords': 'nutritionist services, nutrition programs, VIP support, FMD protocol, child nutrition, group programs, nutritionist consultation',

  'hero.title': 'Our Doors',
  'hero.description': 'Each program is an entrance to a new version of yourself. Choose your path to health and beauty.',

  'service1.title': 'Personal VIP Support',
  'service1.subtitle': 'Tandem',
  'service1.description': 'Full immersion. Daily support. Analysis review, stress work, nutrition for the whole family.',
  'service1.feature1': 'Daily support from two experts',
  'service1.feature2': 'Deep analysis review',
  'service1.feature3': 'Stress and emotional state work',
  'service1.feature4': 'Individual nutrition protocols',
  'service1.feature5': 'Support for the whole family',

  'service2.title': 'FMD Protocol',
  'service2.subtitle': 'Cellular Rejuvenation',
  'service2.description': '5 days of biohacking. Minus biological age, plus infinite energy. Science in service of your youth.',
  'service2.feature1': '5-day scientific protocol',
  'service2.feature2': 'Cellular body renewal',
  'service2.feature3': 'Biological age reduction',
  'service2.feature4': 'Increased energy and mental clarity',
  'service2.feature5': 'Detoxification at cellular level',

  'service3.title': 'Child Nutrition',
  'service3.subtitle': 'The Future Starts on the Plate',
  'service3.description': 'Healthy eating behavior from the cradle. Work with allergies, pickiness and immunity.',
  'service3.feature1': 'Formation of healthy eating habits',
  'service3.feature2': 'Work with food allergies',
  'service3.feature3': 'Solving pickiness problems',
  'service3.feature4': 'Immunity strengthening',
  'service3.feature5': 'Growth and development support',

  'service4.title': 'Group Intensives',
  'service4.subtitle': 'Community Energy',
  'service4.description': 'Gentle protocols for those who want a quick and quality start under our supervision.',
  'service4.feature1': 'Work in mini-groups of 3-4 people',
  'service4.feature2': 'Energy and support of like-minded people',
  'service4.feature3': 'Structured protocols',
  'service4.feature4': 'Regular group calls',
  'service4.feature5': 'Affordable cost',

  'learnMore': 'Learn More',
  'learnMoreAria': 'Learn more about {{service}}',

  'cta.title': 'Don\'t know what to choose?',
  'cta.description': 'Sign up for a free diagnostic, and we\'ll select the perfect program for you',
  'cta.button': 'Book Diagnostic',
  'cta.buttonAria': 'Book a free diagnostic consultation',
};